var exports = {
  "z": "MessageAvatar.module__characterImageButton___R1VSUW",
};

module.exports = exports;
